import React from 'react';
import { motion } from 'framer-motion';

// Array for the single-row highlights
const highlights = [
  {
    text: '⚡ 5× Faster Processing',
  },
  {
    text: '💧 Chemical-Free',
  },
  {
    text: '🌱 Sustainable',
  },
  {
    text: '⚙️ Compact & Scalable',
  },
  {
    text: '♻️ Low Maintenance',
  },
];

// --- START: NEW ARRAY FOR TWO-COLUMN LIST ---
const detailedFeatures = [
  { title: 'Proven Pilot Installations' },
  { title: 'Modular & Scalable Design' },
  { title: 'Integrated IoT Monitoring' },
  { title: 'R&D and Industrial Expertise' }
];
// --- END: NEW ARRAY ---

const WhyUs = () => {
  return (
    <section id="why-us" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Hydrocawach?
          </h2>

          <div className="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
        </motion.div>

        {/* Single-row 5-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {highlights.map((highlight, index) => (
            <motion.div
              key={highlight.text}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border h-full flex items-center justify-center"
            >
              <h3 className="text-xl font-bold text-gray-800 text-center">{highlight.text}</h3>
            </motion.div>
          ))}
        </div>

        {/* --- START: NEW TWO-COLUMN SECTION --- */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-8">
          {detailedFeatures.map((feature, index) => (
            <motion.div
              key={feature.title}
              s initial={{ opacity: 0, x: (index % 2 === 0) ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (index % 2) * 0.1 }}
              e className="flex items-center p-6 bg-white rounded-lg shadow-lg border-l-4 border-blue-600"
            >
              {/* Checkmark Icon */}
              <div className="flex-shrink-0">
                <svg className="h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="ml-4 text-lg font-semibold text-gray-800">{feature.title}</h3>
            </motion.div>
          ))}
        </div>
        {/* --- END: NEW TWO-COLUMN SECTION --- */}

      </div>
    </section>
  );
};

export default WhyUs;